'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.copyToClipboard = void 0;
var tslib_1 = require("tslib");
function copyToClipboard(text) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var _a;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    if (!(typeof navigator.clipboard.writeText === 'function')) return [3 /*break*/, 2];
                    return [4 /*yield*/, navigator.clipboard.writeText(text)];
                case 1:
                    _b.sent();
                    _b.label = 2;
                case 2: return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    console.error('copy to clipboard failed', text);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.copyToClipboard = copyToClipboard;
